import { Modal } from "react-bootstrap";
import { useState, useEffect } from "react";
import axios from "axios";
import ReactTost from "../../ReactTost";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";

const UserDocEdit = (props) => {
    let user = localStorage.getItem("id");
    const { handleSubmit, register, formState: { errors }, setValue, reset} = useForm()
    const{t} = useTranslation();
    const [messageType, setMessageType] = useState("");
    const [message, setMessage] = useState("");
    const [showAlert, setShowAlert] = useState(false);
    const API_URL = process.env.REACT_APP_API_URL;
    const API_VERSION = process.env.REACT_APP_API_VERSION;

    useEffect(() => {
        axios
            .get(`${API_URL}/${API_VERSION}/user_doc/${props.id}`, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("token")}`,
                },
            })
            .then((response) => {
                setValue('name', response.data.name)
            })
            .catch((error) => {
                setMessageType("Danger");
                setMessage(t("Something went to wrong."));
                setShowAlert(true);
            });
    }, [props.id, API_URL, API_VERSION]);

    function updateData(data) {
        if (data.name) {
            axios
                .patch(
                    `${API_URL}/${API_VERSION}/user_doc/${props.id}`,
                    {
                        name: data.name,
                        user,
                    },
                    {
                        headers: {
                            Authorization: `Bearer ${localStorage.getItem("token")}`,
                        },
                    }
                )
                .then((response) => {
                    props.doc();
                    setMessageType("Success");
                    setMessage(t("File is update successfully."));
                    setShowAlert(true);
                    props.onHide();
                   
                })
                .catch((error) => {
                    console.log(error)
                    setMessageType("Danger");
                    setMessage(t("Something went to wrong."));
                    setShowAlert(true);
                });
        }
    }

    const handleClose = () => {
        reset();
        props.onHide();
      };
    
    return (
        <>
            <section className="client_main">
                <ReactTost
                    onHide={() => {
                        setShowAlert(false);
                        setMessageType("");
                        setMessage("");
                    }}
                    alertClass={messageType}
                    alertMessage={message}
                    alertDo={showAlert}
                />
                <Modal {...props} size="md" aria-labelledby="contained-modal-title-vcenter" backdrop="static" centered onHide={handleClose}>
                    <form onSubmit={handleSubmit(updateData)}>
                        <Modal.Header closeButton>
                            <Modal.Title id="contained-modal-title-vcenter">
                                {t("Edit Document")}
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <div className="form-group mb-3">
                                <label className="form-label">{t("Title")}</label>
                                <input type="text" className={`form-control ${errors.name ? 'is-invalid' : ''}`}id="name" name="name" {...register('name', { required: "name is required" })} />
                                {errors.name && <div className="invalid-feedback">{errors.name.message}</div>}
                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            <input type="submit" value="Update" className="button px-md-4 py-md-3" onClick={(e) => updateData(e)}/>
                        </Modal.Footer>
                    </form>
                </Modal>
            </section>
        </>
    )
}
export default UserDocEdit